// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__3T3rd","buttons":"SendReceipts_buttons__3DI6o","email":"SendReceipts_email__1BchZ","bookApptTitle":"SendReceipts_bookApptTitle__3RHVh"};